import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../utils/updateObject';
import { inviteSignup } from '../actions';
import { i18n } from '../../translate/i18n';

const initialState = {
  users: { count: 0, rows: [] },
  usersFilter: {
    pageUser: 1,
    limitUser: 5,
    orderByUser: 'name',
    filteredRoles: [],
  },
  loading: false,
  usersInvitations: { count: 0, rows: []},
  loadingUsersInvitations: false,
  loadingTenantUsers: false,
  // Roles to the filter
  roles: [{
    value: 'admin',
    label: 'Administrador',
  },{
    value: 'analyst',
    label: 'Analista',
  }, {
    value: 'contractor',
    label: 'Empresa Terceira',
  }],
};

const requestUsersStart = (state, action) => {
  return updateObject(state, { loading: true });
};

const setUsersFilter = (state, action) => {
  return updateObject(state, { usersFilter: action.usersFilter});
};

const setUsersRolesFilter = (state, action) => {
  return updateObject(state, {
      usersFilter: {
        ...state.usersFilter,
        filteredRoles: action.roles,
      }
  });
}

const clearUsersFilter = (state, action) => {
  return updateObject(state, {
      usersFilter: {
        ...state.usersFilter,
        filteredRoles: [],
      }
  });
}

const removeUsersRolesFilter = (state, action) => {
  const { filteredRoles } = state.usersFilter;
  let aux = [...filteredRoles];
  const newFilteredRoles = aux.filter((el) => el.value !== action.role.value);
  return updateObject(state, {
      usersFilter: {
        ...state.usersFilter,
        filteredRoles: newFilteredRoles,
      }
  });
}

const fetchUsersSuccess = (state, action) => {
  return updateObject(state, {
    users: action.users,
    loading: false
  });
};

const fetchUserByIdSuccess = (state, action) => {
    return updateObject(state, {
      user: action.user,
      loading: false
    });
};

const requestUsersFail = (state, action) => {
  return updateObject(state, { loading: false });
};

const requestUsersInvitationsStart = (state, action) => {
  return updateObject(state, { loadingUsersInvitations: true });
};

const fetchUsersInvitationsSuccess = (state, action) => {
  return updateObject(state, {
    usersInvitations: action.usersInvitations,
    loadingUsersInvitations: false
  });
};

const requestUsersInvitationsFail = (state, action) => {
  return updateObject(state, { loadingUsersInvitations: false });
};

const deleteUsersSuccess = (state, action) => {
  return updateObject(state, { loading: false });
}

const updateUsersSuccess = (state, action) => {
  return updateObject(state, { loading: false });
}

const postUsersSuccess = (state, action) => {
  return updateObject(state, { loading: false });
}

const forgotPasswordSuccess = (state, action) => {
  return updateObject(state, { loading: false });
}

const inviteSignupSuccess = (state, action) => {
  return updateObject(state, { loading: false });
};

const requestUsersBySuperadminStart = (state, action) => {
  return updateObject(state, { loadingTenantUsers: true });
};

const updateUsersBySuperadminSuccess = (state, action) => {
  return updateObject(state, { loadingTenantUsers: false });
};

const requestUsersBySuperadminFail = (state, action) => {
  return updateObject(state, { loadingTenantUsers: false });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.REQUEST_USERS_START: return requestUsersStart(state, action);
    case actionTypes.FETCH_USERS_SUCCESS: return fetchUsersSuccess(state, action);
    case actionTypes.REQUEST_USERS_FAIL: return requestUsersFail(state, action);
    case actionTypes.DELETE_USERS_SUCCESS: return deleteUsersSuccess(state, action);
    case actionTypes.UPDATE_USERS_SUCCESS: return updateUsersSuccess(state, action);
    case actionTypes.POST_USERS_SUCCESS: return postUsersSuccess(state, action);
    case actionTypes.FETCH_USER_BY_ID_SUCCESS: return fetchUserByIdSuccess(state, action);
    case actionTypes.FORGOT_PASSWORD_SUCCESS: return forgotPasswordSuccess(state, action);
    case actionTypes.SET_USERS_FILTER: return setUsersFilter(state, action);    
    case actionTypes.REQUEST_USERS_INVITATIONS_START: return requestUsersInvitationsStart(state, action);
    case actionTypes.FETCH_USERS_INVITATIONS_SUCCESS: return fetchUsersInvitationsSuccess(state, action);
    case actionTypes.REQUEST_USERS_INVITATIONS_FAIL: return requestUsersInvitationsFail(state, action);
    case actionTypes.INVITE_SIGNUP_SUCCESS: return inviteSignupSuccess(state, action);
    case actionTypes.REQUEST_UPDATE_USER_BY_SUPERADMIN_START: return requestUsersBySuperadminStart(state, action);
    case actionTypes.UPDATE_USERS_SUCCESS: return updateUsersBySuperadminSuccess(state, action);
    case actionTypes.UPDATE_USER_BY_SUPERADMIN_SUCCESS: return updateUsersBySuperadminSuccess(state, action);
    case actionTypes.REQUEST_UPDATE_USER_BY_SUPERADMIN_FAIL: return requestUsersBySuperadminFail(state, action);
    case actionTypes.SET_USERS_ROLES_FILTER: return setUsersRolesFilter(state, action);
    case actionTypes.CLEAR_USERS_FILTER: return clearUsersFilter(state, action);
    case actionTypes.REMOVE_USERS_ROLES_FILTER: return removeUsersRolesFilter(state, action);
    default: return state;
  }
};

export default reducer;
